import { rem } from '@mantine/core';
import type React from 'react';

/** Violet "AI" pill used on every AI card (285-hue tint). */
export function AiPill({ children }: { children: React.ReactNode }) {
  return (
    <span
      style={{
        fontSize: rem(11),
        padding: '1px 7px',
        borderRadius: 20,
        background: 'oklch(0.96 0.02 285)',
        color: 'oklch(0.42 0.07 285)',
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </span>
  );
}

export const SMALL_BTN: React.CSSProperties = {
  cursor: 'pointer',
  padding: '5px 10px',
  borderRadius: 6,
  border: '1px solid oklch(0.9 0.006 95)',
  background: 'oklch(0.985 0.004 95)',
  fontSize: rem(12),
  fontFamily: 'inherit',
  color: 'oklch(0.38 0.012 90)',
};

export const hhmm = (iso: string) =>
  new Date(iso).toLocaleTimeString('sl-SI', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });

export const refreshedAt = (iso: string) => {
  const d = new Date(iso);
  const sameDay = d.toDateString() === new Date().toDateString();
  return sameDay
    ? `osveženo ob ${hhmm(iso)}`
    : `osveženo ${d.toLocaleDateString('sl-SI', { day: 'numeric', month: 'numeric' })} ob ${hhmm(iso)}`;
};
